import ApiService from "../api";

export default class SuporteService extends ApiService {
    constructor() {
        super("/api/suporte");
    }

    contactarSuporte(data){
        return this.post(`/contato`, data)
    }
}